module.exports = __webpack_public_path__ + "img/636802908090575601635905424692237389contact_chat1.jpg";